import { useEffect, useState } from "react";
import { Phone, Menu as MenuIcon, X, MapPin } from "lucide-react";
import { restaurant, images } from "../data";

const links = [
  { label: "Speisekarte", href: "#menu", id: "nav-menu" },
  { label: "Bewertungen", href: "#reviews", id: "nav-reviews" },
  { label: "Öffnungszeiten", href: "#info", id: "nav-info" },
  { label: "Kontakt", href: "#contact", id: "nav-contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-3 group">
          <img
            src={images.logo}
            alt="Zum Goldenen Döner & Pizza Haus Logo"
            width="56"
            height="56"
            className="h-14 w-14 flex-shrink-0 rounded-full object-cover ring-1 ring-[#eab308]/40 transition-transform duration-200 group-hover:scale-105"
          />
          <span className="hidden sm:block leading-tight">
            <span className="block font-display font-black text-lg tracking-tight text-[#f5f5f0]">
              Zum Goldenen Döner
            </span>
            <span className="block text-[11px] uppercase tracking-[0.25em] text-[#eab308]">
              & Pizza Haus
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-sm font-medium text-[#a3a3a3] hover:text-[#f5f5f0] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={restaurant.phoneHref}
            data-testid="header-call-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#e05d36] hover:bg-[#c94925] text-black font-semibold text-sm px-5 py-2.5 transition-[transform,background-color] duration-200 hover:-translate-y-0.5"
          >
            <Phone size={16} strokeWidth={2.5} />
            Anrufen
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden grid place-items-center h-11 w-11 rounded-full border border-white/15 text-[#f5f5f0]"
            aria-label="Menü"
          >
            {open ? <X size={20} /> : <MenuIcon size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-b border-white/10 px-6 py-6 space-y-1">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-base font-medium text-[#e5e5e0] border-b border-white/5"
            >
              {l.label}
            </a>
          ))}
          <a
            href={restaurant.phoneHref}
            data-testid="mobile-call-btn"
            className="mt-4 flex items-center justify-center gap-2 rounded-full bg-[#e05d36] text-black font-semibold py-3"
          >
            <Phone size={18} /> {restaurant.phone}
          </a>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(restaurant.mapsQuery)}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center gap-2 rounded-full border border-white/15 text-[#f5f5f0] py-3"
          >
            <MapPin size={18} /> Route
          </a>
        </div>
      )}
    </header>
  );
}
